import React from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, Heart, Calendar, MessageSquare, Settings, LogOut, FileText, BarChart } from 'lucide-react';
export const DashboardLayout = ({
  type = 'buyer'
}: {
  type?: 'buyer' | 'seller';
}) => {
  const location = useLocation();
  const buyerLinks = [{
    icon: LayoutDashboard,
    label: 'Overview',
    path: '/dashboard/buyer'
  }, {
    icon: Heart,
    label: 'Saved Properties',
    path: '/dashboard/buyer/saved'
  }, {
    icon: Calendar,
    label: 'Inspections',
    path: '/dashboard/buyer/inspections'
  }, {
    icon: MessageSquare,
    label: 'Messages',
    path: '/dashboard/buyer/messages'
  }, {
    icon: Settings,
    label: 'Settings',
    path: '/dashboard/buyer/settings'
  }];
  const sellerLinks = [{
    icon: LayoutDashboard,
    label: 'Overview',
    path: '/dashboard/seller'
  }, {
    icon: FileText,
    label: 'My Listings',
    path: '/dashboard/seller/listings'
  }, {
    icon: BarChart,
    label: 'Analytics',
    path: '/dashboard/seller/analytics'
  }, {
    icon: MessageSquare,
    label: 'Inquiries',
    path: '/dashboard/seller/inquiries'
  }, {
    icon: Settings,
    label: 'Settings',
    path: '/dashboard/seller/settings'
  }];
  const links = type === 'buyer' ? buyerLinks : sellerLinks;
  return <div className="min-h-screen flex bg-neutral-light" data-id="element-126">
      {/* Sidebar */}
      <aside className="w-64 bg-white border-r border-neutral-200 hidden md:flex flex-col fixed h-full z-10" data-id="element-127">
        <div className="p-6 border-b border-neutral-200" data-id="element-128">
          <Link to="/" className="flex items-center gap-2" data-id="element-129">
            <div className="w-8 h-8 rounded bg-primary-900 flex items-center justify-center font-serif font-bold text-xl text-secondary" data-id="element-130">
              A
            </div>
            <span className="font-serif font-bold text-2xl tracking-tight text-primary-900" data-id="element-131">
              AMU
            </span>
          </Link>
        </div>

        <div className="p-4 flex-grow" data-id="element-132">
          <div className="text-xs font-bold text-neutral-dark uppercase tracking-wider mb-4 px-3" data-id="element-133">
            {type === 'buyer' ? 'Buyer Menu' : 'Seller Menu'}
          </div>
          <nav className="space-y-1" data-id="element-134">
            {links.map(link => {
            const isActive = location.pathname === link.path;
            const Icon = link.icon;
            return <Link key={link.path} to={link.path} className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${isActive ? 'bg-primary-50 text-primary-900' : 'text-text-light hover:bg-neutral-100 hover:text-text'}`} data-id="element-135">
                  <Icon size={18} className={isActive ? 'text-primary-900' : 'text-neutral-dark'} data-id="element-136" />
                  {link.label}
                </Link>;
          })}
          </nav>
        </div>

        <div className="p-4 border-t border-neutral-200" data-id="element-137">
          <button className="flex items-center gap-3 px-3 py-2.5 w-full rounded-lg text-sm font-medium text-error hover:bg-error/10 transition-colors" data-id="element-138">
            <LogOut size={18} data-id="element-139" />
            Logout
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-grow md:ml-64 flex flex-col min-h-screen" data-id="element-140">
        {/* Mobile Header */}
        <header className="bg-white border-b border-neutral-200 p-4 flex items-center justify-between md:hidden sticky top-0 z-20" data-id="element-141">
          <Link to="/" className="font-serif font-bold text-xl text-primary-900" data-id="element-142">
            AMU
          </Link>
          <button className="p-2 text-text" data-id="element-143">
            <LayoutDashboard size={20} data-id="element-144" />
          </button>
        </header>

        <div className="p-6 md:p-8 flex-grow" data-id="element-145">
          <Outlet data-id="element-146" />
        </div>
      </main>
    </div>;
};